import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 50000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
// console.log("came in")
instance.interceptors.request.use(async (config) => {
  let adminInfo = localStorage.getItem("adminInfo"); // BEARER token
  let authKey = localStorage.getItem("authkey");     // access token
  let company = Cookies.get("company") || "";

  // console.log("Before API Call 👇");
  // console.log("adminInfo (Bearer):", adminInfo);
  // console.log("authKey (access token):", authKey);

  // If adminInfo is missing, fetch it
  if (!adminInfo) {
    // console.log("adminInfo missing → fetching new token");

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/login`,
      {
        username: "Admin Panel",
        password: "Admin@123",
      },
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.status === 200 && response.data.status) {

      adminInfo = response.data.token || response.data.key;

      localStorage.setItem("adminInfo", adminInfo);

      // console.log("New adminInfo saved:", adminInfo);

    } else {
      throw new Error("Admin login failed");
    }
  }

  // If authkey is missing
  if (!authKey) {
    console.warn("authkey is missing in localStorage");
  }

  // Final headers being sent
  // config.headers.authorization = `Bearer ${adminInfo}`;
  config.headers.authorization = `Bearer ${adminInfo.token}`;
  config.headers.accesstoken = authKey;
  config.headers.company = company;

  // console.log("Headers sent with request 👇");
  // console.log("Authorization:", config.headers.authorization);
  // console.log("accesstoken:", config.headers.accesstoken);
  // console.log("company:", config.headers.company);

  return config;
});


const responseBody = (response) => response.data;

const requests = {
  get: (url, body, headers) =>
    instance.get(url, body, headers).then(responseBody),

  post: (url, body,) => instance.post(url, body).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url, body) => instance.delete(url, body).then(responseBody),
};

export default requests;
